import { render, staticRenderFns } from "./groceryListing.vue?vue&type=template&id=31d36e7c&scoped=true"
import script from "./groceryListing.vue?vue&type=script&lang=js"
export * from "./groceryListing.vue?vue&type=script&lang=js"
import style0 from "./groceryListing.vue?vue&type=style&index=0&id=31d36e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d36e7c",
  null
  
)

export default component.exports